import template from "./edit_project.html";
import tr from '../../lib/default-translator.js';

class EditProjectViewModel
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.company_id = ko.observable();
		this.task_id = ko.observable();
		this.transaction_types = ko.observableArray();
		this.transaction_type_id = ko.observable();
		this.task_description = ko.observable();
	}

	async save_project()
	{
		//validation
		if (!this.task_description())
		{
			Grape.alerts.alert({type: "error", message: tr("Please enter a description"), title: tr("Error", "Error")});
			return;
		}

		let data = {
			task_id: this.task_id(),
			task_description: this.task_description(),
			transaction_type_id: this.transaction_type_id(),
			company_id: this.company_id(),
		};

		let res = await Grape.fetches.postJSON("/time_management/project_upsert", data);
		if (res.status == "OK")
		{
			await Grape.alerts.alert({type: "success", message: tr("Successfully saved project."), title: tr("Success", "Success")});
			this.close();
		}
		else if (res.status == "ERROR")
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: "error", message: tr(	"Something went wrong...", "Something went wrong..."), title: tr("Error", "Error")});
	};

	close()
	{
		this.dialog.close();
	}

};

class EditProjectPage
{
	constructor(bindings)
	{
		this.viewModel = new EditProjectViewModel(this);
		this.bindings = bindings;
	}

	async init()
	{
		
		if (this.bindings.company_id)
			this.viewModel.company_id(this.bindings.company_id);

		if (this.bindings.row)
		{
			if (this.bindings.row.company_id) 
				this.viewModel.company_id(this.bindings.row.company_id);
			
			if (this.bindings.row.task_id) 
				this.viewModel.task_id(this.bindings.row.task_id);
	
			await this.get_transaction_types();
			
			if (this.bindings.row.user_description)
			{
				let matchingTransactionType = ko.utils.arrayFirst(
					this.viewModel.transaction_types(), 
					(a) => a.description === this.bindings.row.user_description
				);

				if (matchingTransactionType) 
					this.viewModel.transaction_type_id(matchingTransactionType.transaction_type_id);
			}
	
			if (this.bindings.row.id) 
				this.viewModel.transaction_type_id(this.bindings.row.id);

			if (this.bindings.row.task_description) 
				this.viewModel.task_description(this.bindings.row.task_description);
			
		}
		else
			await this.get_transaction_types();
	}

	
	async get_transaction_types()
	{
		//get all the employees
		let filter = [];
		if (this.viewModel.company_id())
		{
			filter = [{
				value: this.viewModel.company_id(),
				operand: "=",
				field: "company_id",
			}];
		}

		let res = await Grape.fetches.getJSON("/api/record", {
			table: "transaction_type_user",
			schema: "public",
			limit: 1000000,
			filter: filter,
		});

		if (res.records != null)
			this.viewModel.transaction_types(res.records);
	};
};

export default {
	name: "EditProject",
	dialog_class: EditProjectPage,
	template: template,
	template_filename: "translation/dialogs/edit_project",
	provider: 'ps'
};